// extracted by mini-css-extract-plugin
export var dropdownButton = "_1e-0";
export var fullWidthDropdownButton = "_1e-1";
export var icon = "_1e-3";
export var iconPlaceholder = "_1e-2";
export var menuItemRow = "_1e-9";
export var separator = "_1e-e";
export var shortcutContainer = "_1e-7";
export var shortcutContainerFilled = "_1e-8";
export var shortcutIconLg = "_1e-6";
export var shortcutIconMd = "_1e-5";
export var shortcutIconSm = "_1e-4";
export var submenuChevron = "_1e-d";
export var submenuDropdown = "_1e-a";
export var submenuTriggerRow = "_1e-b";
export var submenuTriggerRowOpen = "_1e-c";